import { authApi, setLogIn, setMe } from 'entities/auth';
import { usersApi } from 'entities/users';

const authApiSignIn = authApi.injectEndpoints({
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (form) => ({
        url: '/account/login/access-token',
        method: 'POST',
        body: form,
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const { access_token, refresh_token } = data;
          dispatch(
            setLogIn({
              access_token,
              refresh_token,
            }),
          );
          const { data: me } = await dispatch(usersApi.endpoints.getMe.initiate(null));
          dispatch(setMe(me));
        } catch (err) {}
      },
    }),
    refreshToken: builder.mutation({
      query: () => ({
        url: '/admin/login/refresh-token',
        method: 'POST',
        body: localStorage.getItem('refresh_token'),
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useSignInMutation, useRefreshTokenMutation } = authApiSignIn;
